import React, { useEffect, useReducer, useState } from 'react';
import Notification from '../Common/Notification';
import CallOut from '../Common/CallOut';
import TextInput from '../Common/TextInput';
import ActivityLoader from '../Common/ActivityLoader';
import { useStudent } from '../../DataStore/StudentContext';
import ajaxStudent from '../../util/remote/ajaxStudent';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    contactName: '',
    contactPhone: '',
    contactType: '',
    loading: false,
}

const EditContact = ({contact}) => {

    const [currentNotify, setNotify] = useState(null);

    const [state, dispatch] = useReducer(reducer, initialState);

    const {getContactTypes, contactTypes, getStudentContacts} = useStudent();

    useEffect(() => {
        getContactTypes();
    }, []);

    useEffect(() => {
        if (contact) {
            dispatch({type: 'contactName', value: contact.contact.contact_name});
            dispatch({type: 'contactPhone', value: contact.contact.contact});
            dispatch({type: 'contactType', value: {label: contact.contact.contact_type.type_name, value: contact.contact.contact_type.id}});
        }
    }, [contact]);

    const contactTypeOptions = Array.isArray(contactTypes) ? contactTypes.map(type => ({
        value: type.id,
        label: type.type_name
    })) : [];



    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);

    const handleSave = async (event) =>{
        event.preventDefault();
        if(state.loading){
            return;
        }

        if(state.contactName.length === 0 || state.contactPhone.length === 0 || !state.contactType.value === 0){
            setNotify(<Notification type='danger' message="Please fill in all fields."/>);
            return;
        }

        dispatch({type: 'loading', value: true});
        const server_response = await ajaxStudent.updateContact({
            contact_id: contact.contact?.id,
            phone_number: state.contactPhone,
            contact_name: state.contactName,
            contact_type: state.contactType.value,
        });
        dispatch({type: 'loading', value: false});
        if(server_response.status==="OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);
            getStudentContacts(contact.contact.student_id); // Refresh contacts
           
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>);

        }

    }


     

  

    return (
        <div className="card-body">

            <CallOut 
                title={`Edit Contact`}
                description={"Update student contact."}
             />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

                <TextInput
                    type="text"
                    label="Contact Name"
                    placeholder="Enter contact name"
                    leftIcon="fa fa-user"
                    value={state.contactName}
                    onChange={e => dispatch({type: 'contactName', value: e.target.value})}
                    required
                    wrap
                    />
                <TextInput
                    type="text"
                    label="Phone Number"
                    placeholder="Enter contact phone number"
                    leftIcon="fa fa-phone"
                    value={state.contactPhone}
                    onChange={e => dispatch({type: 'contactPhone', value: e.target.value})}
                    required
                    wrap
                    />

                <TextInput
                    type="select"
                    label="Contact Type"
                    placeholder={state.contactType?.label || "Select contact type"}
                    leftIcon="fa fa-address-card"
                    value={state.contactType.id}
                    onChange={item => dispatch({type: 'contactType', value: item})}
                    options={contactTypeOptions}
                    required
                    wrap
                    />
                

                    <div className="text-right">
                        {!state.loading && <button type="submit" className="btn btn-lg btn-success">Save Changes</button>}
                        {state.loading && <ActivityLoader />}
                    </div>

            </form> 


        </div>
    );
};

export default EditContact;